import React from 'react'

import AdvertCreatePage from '../../screens/AdvertCreatePage/AdvertCreatePage.component'

const AdvertsCreate: React.FC = () => {
  return (
    <AdvertCreatePage />
  )
}

export default AdvertsCreate
